import { addDays, addWeeks, format, getTime, subDays } from "date-fns";
import usLocale from "date-fns/locale/en-US";
import esLocale from "date-fns/locale/es";
import { getLocalStorage } from "./handleStorage";
import dayjs from "dayjs";

//const dateFormat = 'dd/MM/yyyy';

const dateFormat = 'MM/dd/yyyy';

const dateFormatES = 'dd/MM/yyyy';

const dateTimeFormat = dateFormat + ' HH:mm';

const dateTimeFormatES = dateFormatES + ' HH:mm';

export const locale = getLocalStorage('dateFormat') === 'MM_DD_AAAA' ? usLocale : esLocale;

export const formatDate = (date: any) => {
if (date !== undefined) {
    if (date === 0) {
      return '-';
    } else {
      if (getLocalStorage('dateFormat') === 'MM_DD_AAAA') {
        return format(new Date(date), dateFormat);
      } else return format(new Date(date), dateFormatES);
    }
  } else return '-';
};

export const formatDateTime = (date: any) => {
  if (date !== undefined) {
    if (date === 0) {
      return '-';
    } else {
      if (getLocalStorage('dateFormat') === 'MM_DD_AAAA') {
        return format(new Date(date), dateTimeFormat);
      } else return format(new Date(date), dateTimeFormatES);
    }
  } else return '-';
};

export const dateCompare = (date1: any, date2: any) => {
  return new Date(date2) > new Date(date1);
};

export const customFormatDate = (date: any, type: string) => format(new Date(date), type);

export const toTimestamp = (date: any) => dayjs(date).valueOf();

/**
 * Marca de tiempo para un cambio de estado del servicio.
 *
 * El selector del formulario es de día, así que la hora que arrastra la fecha elegida no
 * significa nada: si se deja el día de hoy se manda el instante real del guardado, y si el
 * operador retrocede a un día pasado (backdating deliberado) se manda ese día a las 00:00.
 * Sin esto se enviaba la hora en que montó el formulario, que llegaba a quedar por detrás
 * del cambio de estado anterior y descolocaba la línea temporal del paciente.
 */
export const toStateChangeTimestamp = (date: any) => {
  const selected = dayjs(date);
  if (!selected.isValid()) return NaN;
  return selected.isSame(dayjs(), 'day') ? Date.now() : selected.startOf('day').valueOf();
};

export const addWeeksDate = (date: Date | number, weeks: number) => addWeeks(date, weeks);

export const addDaysDate = (date: Date | number, days: number) => addDays(date, days);

export const subDaysDate = (date: Date | number, days: number) => subDays(date, days);

export const dateDiff = (from: number, to: number) => {
  const ms = Math.max(0, dayjs(to).diff(dayjs(from)));

  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const pad = (n: number) => String(n).padStart(2, '0');

  return `${hours}:${pad(minutes)}:${pad(seconds)}`;
};

export const dateDiffWithNow = (date: number) => dateDiff(date, dayjs().valueOf());

export const secondsDiffWithNow = (date: number) => {
  return dayjs().diff(dayjs(date)) / 1000;
};

export const europeanFormatToUsFormat = (euDate: string) => {
  const parts = euDate.split('/');
  return parts[1] + '/' + parts[0] + '/' + parts[2];
};

export const dateDiffWithTodayDetail = (timestamp: number) => {
  const date1 = new Date(timestamp);
  const date2 = new Date(Date.now());

  let difference = Math.abs(date2.getTime() - date1.getTime());

  const daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
  difference -= daysDifference * 1000 * 60 * 60 * 24;

  const hoursDifference = Math.floor(difference / 1000 / 60 / 60);
  difference -= hoursDifference * 1000 * 60 * 60;

  const minutesDifference = Math.floor(difference / 1000 / 60);
  difference -= minutesDifference * 1000 * 60;

  const secondsDifference = Math.floor(difference / 1000);

  return (
    (daysDifference === 0 ? '' : daysDifference + ' d ') +
    (hoursDifference === 0 ? '' : hoursDifference + ' h ') +
    (minutesDifference === 0 ? '' : minutesDifference + ' m ') +
    (secondsDifference === 0 ? '' : secondsDifference + ' s ')
  );
};

export const millisecondsToTime = (timestamp: number) => {
  const date1 = new Date(Date.now() - timestamp);
  const date2 = new Date(Date.now());

  let difference = date2.getTime() - date1.getTime();

  const daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
  difference -= daysDifference * 1000 * 60 * 60 * 24;

  const hoursDifference = Math.floor(difference / 1000 / 60 / 60);
  difference -= hoursDifference * 1000 * 60 * 60;

  const minutesDifference = Math.floor(difference / 1000 / 60);
  difference -= minutesDifference * 1000 * 60;

  const secondsDifference = Math.floor(difference / 1000);

  return (
    (daysDifference === 0 ? '' : daysDifference + ' d ') +
    (hoursDifference === 0 ? '' : hoursDifference + ' h ') +
    (minutesDifference === 0 ? '' : minutesDifference + ' m ') +
    (secondsDifference === 0 ? '' : secondsDifference + ' s ')
  );
};
